import React from "react";
import { DeletePopUp } from "../../../../components/PopUp";
import { DateFormat, formatDate, getNumberFormat } from "../../../../utils";
import { DeleteProgressModalProps } from "./types";

/**
 * Modal for confirming progress/transaction deletion
 * Shows transaction details for confirmation
 */
export const DeleteProgressModal: React.FC<DeleteProgressModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  transaction,
}) => {
  if (!transaction) {
    return null;
  }

  return (
    <DeletePopUp
      isOpen={isOpen}
      setIsOpen={onClose}
      title="Delete saving progress"
      text={
        <>
          Do you really want to delete the progress{" "}
          <strong>{getNumberFormat(transaction.netAmount)}€</strong> of{" "}
          <strong>{formatDate(transaction.date, DateFormat.DMY_SPACE)}</strong>
        </>
      }
      handleOnDelete={onConfirm}
    />
  );
};
